export const DEVICE_TYPES = [
  { text: 'All Devices', value: 'all' },
  { text: 'Desktop', value: 'desktop' },
  { text: 'Tablet', value: 'tablet' },
  { text: 'Mobile', value: 'mobile' },
]

export const STATUS_COLOR_MAP = {
  active: 'success',
  new: 'info',
  ns_ready: 'grey darken-1',
  password_protected: 'warning',
  error: 'error',
  disabled: 'grey',
  deleted: 'grey',
  draft: 'grey darken-1',
  maintenance: 'grey darken-2',
}

export const statusColor = (status) =>
  STATUS_COLOR_MAP[String(status || '').toLowerCase()] ?? 'grey'

export const DEFAULT_GEO_RULE_OPTIONS = [
  { text: 'Allow', value: 'allow' },
  { text: 'Deny', value: 'deny' },
  { text: 'Redir', value: 'redir' },
]

export const AUDIT_LOG_TYPE = {
  MIRROR: 'mirror',
  GROUP_MIRROR: 'group_mirror',
  REDIRECTOR: 'redirector',
  MAIN_SETTINGS: 'main_settings',
}

export const AUDIT_LOG_TYPE_OPTIONS = [
  { text: 'Main Settings', value: AUDIT_LOG_TYPE.MAIN_SETTINGS },
  { text: 'Mirrors Groups', value: AUDIT_LOG_TYPE.GROUP_MIRROR },
  { text: 'Mirrors', value: AUDIT_LOG_TYPE.MIRROR },
  { text: 'Redirectors', value: AUDIT_LOG_TYPE.REDIRECTOR },
]

export const AUDIT_LOG_SORT_ORDER = {
  DESC: 'desc',
  ASC: 'asc',
}

export const AUDIT_LOG_SORT_ORDER_OPTIONS = [
  { text: 'Newest first', value: AUDIT_LOG_SORT_ORDER.DESC },
  { text: 'Oldest first', value: AUDIT_LOG_SORT_ORDER.ASC },
]

const TAB_TO_AUDIT_LOG_TYPE = {
  'main-settings': AUDIT_LOG_TYPE.MAIN_SETTINGS,
  'mirrors-groups': AUDIT_LOG_TYPE.GROUP_MIRROR,
  mirrors: AUDIT_LOG_TYPE.MIRROR,
  redirectors: AUDIT_LOG_TYPE.REDIRECTOR,
}

export function auditLogTypeFromTab(tab) {
  return TAB_TO_AUDIT_LOG_TYPE[tab] ?? AUDIT_LOG_TYPE.MAIN_SETTINGS
}
